export default {
  pagesLogin: {
    title1: 'Đăng nhập hệ thống trò chơi điện tử',
    title2: 'Đăng nhập hệ thống',
    title3: 'Tài khoản thanh toán',
    title4: 'mật khẩu',
    title5: 'Mã xác nhận',
    title6: 'Mã xác minh của Google',
    title7: 'Đăng nhập nền tảng',
    title8: 'Mã nền tảng',
    btn: 'đăng nhập',
    message1: 'Điền mã nền tảng',
    message2: 'Vui lòng nhập tài khoản',
    message3: 'Vui lòng nhập mật khẩu',
    message4: 'Điền mã xác minh của Google',
    message5: 'vui lòng nhập mã xác nhận',
    error1: 'Vui lòng nhập 3-8 chữ cái hoặc số',
    error2: 'Vui lòng nhập 5-15 chữ cái hoặc số',
    error3: 'Vui lòng nhập 6-32 chữ cái hoặc số',
    error4: 'Vui lòng nhập 5 chữ cái hoặc số',
    error5: 'Tạm thời không có quyền truy cập',
  }
}
